import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { appRoutes } from './app.routing';
import { ResultsComponent } from './Components/TowLocate/results/results.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { FrameworkBodyComponent } from './Components/framework-body/framework-body.component';
import { TitlebarComponent } from './Components/titlebar/titlebar.component';
import { ContentComponent } from './Components/content/content.component';
import { HomePageComponent } from './Components/TowLocate/home-page/home-page.component';
import { TowLocateSubjectService } from './services/TowLocateServices/tow-locate-subject.service';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FwModule } from './fw.module';
import { StatusBarComponent } from './Components/status-bar/status-bar.component';
import { HelpPageComponent } from './Components/TowLocate/help-page/help-page.component';
import {NgxMaskModule} from 'ngx-mask'
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { MultipleResultsComponent } from './Components/TowLocate/multiple-results/multiple-results.component';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

import { MultipleResultServiceService } from './Services/TowLocateServices/multiple-result-service.service';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
} from '@angular/material';
@NgModule({
  declarations: [
    AppComponent,
    FrameworkBodyComponent,
    TitlebarComponent,
    ContentComponent,
    HomePageComponent,
    ResultsComponent,
    StatusBarComponent,
    HelpPageComponent,
    MultipleResultsComponent,
    
  ],
  imports: [
    BrowserModule,
    FwModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes),
    NgxMaskModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule
    
  ],
  providers: [TowLocateSubjectService,MultipleResultServiceService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts